import React from "react"
import { Row, Col } from 'react-flexbox-grid';
import styled from 'styled-components';
import MenuBar from 'components/interactive/menu/menu-bar'
import Logotype from './logotype'

/*
DESCRIPTION: Visual header bar for each page, includes logotype and navigation
*/

const HeaderRow = styled(Row)`
	box-sizing:border-box;
	padding-top: 20px;
	padding-right: 15px;
	@media print {
		height: 130px;
		position: relative;
	}
`;

const Header = (props) => {
		return(
			<HeaderRow>
		    <Col 
			    xsOffset={0} xs={12} 
		    	smOffset={0} sm={3} 
		    	mdOffset={0} md={3} 
		    	lgOffset={0} lg={3}
	    	>
		    	<Logotype />
		    </Col>
		    <Col 
		    	xsOffset={0} xs={12} 
		    	smOffset={0} sm={9} 
		    	mdOffset={0} md={9} 
		    	lgOffset={0} lg={9}
				>
		    	<MenuBar location={props.location}/>
		    </Col>
	    </HeaderRow>
		);
	}


export default Header




// WEBPACK FOOTER //
// ./src/layout/header.js